export default "__VITE_ASSET__BIoNGR4O__"